import { css } from '@emotion/css';

export const modalStyling = css`
  top: 35px !important;
`;

export const modalContent = css`
  overflow: hidden !important;
`;
